import { FilterCondition, FilterDTO, FilterOperator, SortDirection } from './../../models/models.swagger.generated';
import { AuthService } from '../auth.service';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ClientClient, ClientDTO, PagedResultDTOOfClientDTO } from 'src/app/base/models/models.swagger.generated';
import { catchError, tap } from 'rxjs/operators';
import { ToastService } from 'src/app/base/services/toast.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ShowInactiveService } from '../../shared/grid-base/show-inactive.service';
import { IAdaptorService } from '../../shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from '../../shared/syncfusion/paged-items.interface';

@Injectable()
export class ClientService extends ShowInactiveService implements IAdaptorService {

  public clients: ClientDTO[];
  public numberOfClients: number;
  public selectedClient: ClientDTO;

  constructor(
    private authService: AuthService,
    private clientAdministrationClient: ClientClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService
  ) {
    super();
  }

  getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    throw new Error('Method not implemented.');
  }
  addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public resolve(): Observable<PagedResultDTOOfClientDTO> {
    return this.getAccessibleClients();
  }

  public getAccessibleClients(filter: FilterDTO[] = null, skip = 0, take = 0): Observable<PagedResultDTOOfClientDTO> {
    const loggedInUser = this.authService.getUserInfo();
    if (loggedInUser.client) {
      this.selectedClient = loggedInUser.client;
      this.clients = [loggedInUser.client];
      return of({
        items: [loggedInUser.client],
        totalNumberOfItems: 1
      } as PagedResultDTOOfClientDTO);
    } else if (this.authService.isUserAdmin()) {
      this.spinnerService.showSpinner = true;

      // const filter = new FilterDTO({
      //   isComplex: false,
      //   field: pagedInput.filterBy,
      //   operator: FilterOperator.Equal,
      //   value: pagedInput.filter
      // });
      if (filter == null) {
        filter = [new FilterDTO({ isComplex: false, field: 'IsActive', operator: FilterOperator.Equal, value: 'true' })]
      }
      return this.clientAdministrationClient.searchClients(filter, 0, 0, 'name', SortDirection.Ascending)
        .pipe(
          tap((pagedResult: PagedResultDTOOfClientDTO) => {
            this.spinnerService.showSpinner = false;
            this.clients = pagedResult.items;
            this.numberOfClients = pagedResult.totalNumberOfItems;
            if (this.numberOfClients === 1) {
              this.selectedClient = this.clients[0];
            }
          }),
          catchError((error: any) => {
            this.spinnerService.showSpinner = false;
            if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
              this.toastService.showError('i18n.errors.server-error.title',
                'i18n.errors.server-error.message', null, ErrorType.serverError);
            }
            return of(error);
          })
        );
    }
    return of({
      items: [],
      totalNumberOfItems: 0
    } as PagedResultDTOOfClientDTO);
  }

  public searchClients(searchTerm: string, take: number): Observable<PagedResultDTOOfClientDTO> {
    const filters = [new FilterDTO({ isComplex: false, field: 'IsActive', operator: FilterOperator.Equal, value: 'true' })];
    searchTerm = searchTerm?.trim();
    if (searchTerm != null && searchTerm.length) {
      filters.push(new FilterDTO({
        isComplex: true,
        condition: FilterCondition.Or,
        predicates: [
          new FilterDTO({ isComplex: false, field: 'Name', operator: FilterOperator.Contains, value: searchTerm })
        ]
      }));
    }

    return this.getAccessibleClients(filters, 0, take);
  }

}
